import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-67539f89")
const _hoisted_1 = { class: "page--limited card" }
const _hoisted_2 = { class: "p-d-flex p-ai-center" }
const _hoisted_3 = { class: "p-d-flex p-ai-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex p-ai-center" }, null, -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "No tickets to bill found.")
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "p-text-center"
}
const _hoisted_9 = { key: 2 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "p-error" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "There are invalid tickets")
], -1)
const _hoisted_11 = { key: 4 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "p-error" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Warning there are Zero Fee tickets")
], -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackButton = _resolveComponent("BackButton")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InvoiceMovementsFilters = _resolveComponent("InvoiceMovementsFilters")!
  const _component_CurrencyText = _resolveComponent("CurrencyText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_BackButton, { to: _ctx.backRoute }, null, 8, ["to"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t('invoiceMovement.edit.title')), 1)
      ]),
      _hoisted_4
    ]),
    _createVNode(_component_InvoiceMovementsFilters, {
      filters: _ctx.advFilters,
      "onUpdate:filters": _cache[1] || (_cache[1] = ($event: any) => (_ctx.advFilters = $event)),
      onChange: _ctx.onFiltersChange
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Calculate and show results",
          class: "p-mr-1",
          disabled: _ctx.requestPending || !_ctx.canCalculate,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.calculateResults()))
        }, null, 8, ["disabled"])
      ]),
      _: 1
    }, 8, ["filters", "onChange"]),
    (_ctx.valid_ticket && _ctx.invalid_tickets && (!_ctx.valid_ticket.length && !_ctx.invalid_tickets.length))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
      : _createCommentVNode("", true),
    (_ctx.valid_ticket?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_DataTable, {
            value: _ctx.valid_ticket,
            loading: _ctx.requestPending,
            "auto-layout": true,
            "striped-rows": true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                class: "center",
                header: "Fee driver"
              }, {
                body: _withCtx(({ data }) => [
                  _createVNode(_component_CurrencyText, {
                    modelValue: data.tot_fee_driver
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                class: "center",
                header: "Fee broker"
              }, {
                body: _withCtx(({ data }) => [
                  _createVNode(_component_CurrencyText, {
                    modelValue: data.tot_fee_broker
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                class: "center",
                header: "Fee customer"
              }, {
                body: _withCtx(({ data }) => [
                  _createVNode(_component_CurrencyText, {
                    modelValue: data.tot_fee_customer
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                class: "center",
                header: "Fee system"
              }, {
                body: _withCtx(({ data }) => [
                  _createVNode(_component_CurrencyText, {
                    modelValue: data.tot_fee_system
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                class: "center",
                header: "Price client"
              }, {
                body: _withCtx(({ data }) => [
                  _createVNode(_component_CurrencyText, {
                    modelValue: data.tot_price_client
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value", "loading"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.invalid_tickets?.length && !_ctx.valid_ticket?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(_component_DataTable, {
            value: _ctx.invalid_tickets,
            loading: _ctx.requestPending,
            "auto-layout": true,
            "striped-rows": true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                field: "shift.code",
                header: "WRS"
              }, {
                body: _withCtx(({data}) => [
                  _createVNode(_component_router_link, {
                    to: {
              name: _ctx.shiftRoute,
              params: { shiftId: data.shift.id }
            },
                    target: "_blank"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" #" + _toDisplayString(data.shift.code), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "id",
                header: "Ticket"
              }, {
                body: _withCtx(({data}) => [
                  _createVNode(_component_router_link, {
                    to: {
              name: _ctx.ticketRoute,
              params: { ticketId: data.id }
            },
                    target: "_blank"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" #" + _toDisplayString(data.id), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "user.fullname",
                header: "Driver"
              }, {
                body: _withCtx(({data}) => [
                  _createVNode(_component_router_link, {
                    to: {
              name: _ctx.userRoute,
              params: { userId: data.user.id }
            },
                    target: "_blank"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(data.user.fullname), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Status" }, {
                body: _withCtx(({data}) => [
                  _createTextVNode(_toDisplayString(_ctx.$t(`ticket.statuses.${_ctx.TicketStatusEnum[data.status]}`)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Payment" }, {
                body: _withCtx(({data}) => [
                  _createTextVNode(_toDisplayString(_ctx.getPaymentStatus(data)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Actions" }, {
                body: _withCtx(({data}) => [
                  (_ctx.canDelete(data))
                    ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        class: "p-button-danger p-mr-1",
                        icon: "pi pi-trash",
                        onClick: _withModifiers(($event: any) => (_ctx.onDelete(data)), ["stop"])
                      }, null, 8, ["onClick"])), [
                        [
                          _directive_tooltip,
                          _ctx.$t('delete'),
                          void 0,
                          { bottom: true }
                        ]
                      ])
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value", "loading"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.canShowCalculateButton)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 3,
          label: "Create movement",
          class: "p-mt-2 p-ml-auto p-mr-auto",
          disabled: _ctx.requestPending || !_ctx.canCalculate,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.createMovement()))
        }, null, 8, ["disabled"]))
      : _createCommentVNode("", true),
    (_ctx.zero_tickets?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(_component_DataTable, {
            value: _ctx.zero_tickets,
            loading: _ctx.requestPending,
            "auto-layout": true,
            "striped-rows": true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                field: "shift.code",
                header: "WRS"
              }, {
                body: _withCtx(({data}) => [
                  _createVNode(_component_router_link, {
                    to: {
              name: _ctx.shiftRoute,
              params: { shiftId: data.shift.id }
            },
                    target: "_blank"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" #" + _toDisplayString(data.shift.code), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "id",
                header: "Ticket"
              }, {
                body: _withCtx(({data}) => [
                  _createVNode(_component_router_link, {
                    to: {
              name: _ctx.ticketRoute,
              params: { ticketId: data.id }
            },
                    target: "_blank"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" #" + _toDisplayString(data.id), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "user.fullname",
                header: "Driver"
              }, {
                body: _withCtx(({data}) => [
                  _createVNode(_component_router_link, {
                    to: {
              name: _ctx.userRoute,
              params: { userId: data.user.id }
            },
                    target: "_blank"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(data.user.fullname), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Status" }, {
                body: _withCtx(({data}) => [
                  _createTextVNode(_toDisplayString(_ctx.$t(`ticket.statuses.${_ctx.TicketStatusEnum[data.status]}`)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Payment" }, {
                body: _withCtx(({data}) => [
                  _createTextVNode(_toDisplayString(_ctx.getPaymentStatus(data)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value", "loading"])
        ]))
      : _createCommentVNode("", true)
  ]))
}